/* libs */
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const SideBarTitle = props => {
	const { onClick, title, to } = props;

	return (
		<Link to={to} className="sidebar-back" onClick={onClick}>
			<i className="fal fa-chevron-left"></i>
			<span> {title}</span>
		</Link>
	);
};

SideBarTitle.propTypes = {
	onClick: PropTypes.func,
	title: PropTypes.string,
	to: PropTypes.string,
};

export default SideBarTitle;
